<template>
  <header
    :class="{
      'header--categories-overlay': $store.state._overlays.categoriesOverlay,
      'header--search-overlay': $store.state._overlays.searchOverlay,
      'header--mobile-search-overlay': $store.state._overlays.mobileSearchOverlay,
    }"
    class="header"
  >
    <HeaderTopComponent />
    <HeaderMainComponent
      @search="searchInput"
      :loading="loading"
      :products="products"
      :total="total"
      :cart-items-length="cartItemsLength"
      :search-placeholder="searchPlaceholder"
    />
    <HeaderBottomComponent :activeId="hoverActiveId" @hoverChange="hoverChange" />
    <HeaderSearchComponent
      @search="searchInput"
      :loading="loading"
      :products="products"
      :total="total"
      :search-placeholder="searchPlaceholder"
    />
    <HeaderDropdownComponent :activeId="hoverActiveId" />
  </header>
</template>

<script>
import HeaderTopComponent from "components/header/components/HeaderTopComponent.vue";
import HeaderMainComponent from "components/header/components/HeaderMainComponent.vue";
import HeaderBottomComponent from "components/header/components/HeaderBottomComponent.vue";
import HeaderSearchComponent from "components/header/components/HeaderSearchComponent.vue";
import HeaderDropdownComponent from "components/header/components/HeaderDropdownComponent.vue";
import PRODUCTS_PAGINATE from "gql/queries/products_paginate.graphql";

export default {
  name: "HeaderComponent",
  data() {
    return {
      hoverActiveId: null,
      isMobile: false,
      products: [],
      loading: false,
      total: undefined,
    };
  },
  mounted() {
    this.isMobile = window.innerWidth <= 860;
  },
  computed: {
    cartItemsLength() {
      return this.$store.state.auth.cart && this.$store.state.auth.cart.length
        ? this.$store.state.auth.cart.length
        : 0;
    },
    count_products() {
      return this.$store.state.marketplace?.count_products || 0;
    },
    searchPlaceholder() {
      if (this.count_products) {
        let plural_word = this.$options.filters.plural_word(
          this.count_products,
          "товара",
          "товара",
          "товаров"
        );
        return `Поиск среди ${this.count_products} ${plural_word}`;
      }
      return `Поиск среди товаров`;
    },
  },
  methods: {
    searchInput(title) {
      if (title) {
        if (this.inputDebounceTimeout) {
          clearTimeout(this.inputDebounceTimeout);
        }
        this.loading = true;
        this.inputDebounceTimeout = setTimeout(() => {
          this.submitSearch(title);
        }, 500);
      } else {
        this.products = [];
      }
    },
    async submitSearch(title) {
      await this.$apollo.provider.defaultClient
        .query({
          query: PRODUCTS_PAGINATE,
          variables: {
            title: title,
            parent: true,
            first: this.isMobile ? 16 : 6,
          },
        })
        .then(({ data }) => {
          this.loading = false;
          this.products = data.products_paginate.data;
          this.total = data.products_paginate.paginatorInfo?.total;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    hoverChange(id) {
      if (id) {
        this.hoverActiveId = id;
      }
      this.$store.state._overlays.categoriesOverlay = !!id;
    },
  },
  components: {
    HeaderSearchComponent,
    HeaderDropdownComponent,
    HeaderBottomComponent,
    HeaderMainComponent,
    HeaderTopComponent,
  },
};
</script>

<style lang="stylus">
.header {
  z-index 11
  position relative

  &--mobile-search-overlay,
  &--search-overlay {
    z-index auto

    .header-search,
    .header-top {
      position relative
      z-index 11
    }

    .header-main {
      position relative
      z-index 15
    }
  }

  &-search__input .input {
    &:focus-within + .search-dropdown {
      opacity 1
      visibility visible
      top 100%
    }
  }
}
</style>
